export default __webpack_public_path__ + "static/media/hero.549283ed.png";